module.exports = __webpack_public_path__ + "img/whatsapp.41c8c4a5.png";